import {SupportedTimezone} from "../api/generated";

const supportedTimezoneToIanaMap: Record<SupportedTimezone, string> = {
    [SupportedTimezone.EuropeLondon]: "Europe/London",
    [SupportedTimezone.EuropeParis]: "Europe/Paris",
    [SupportedTimezone.EuropeBerlin]: "Europe/Berlin",
    [SupportedTimezone.EuropeMadrid]: "Europe/Madrid",
    [SupportedTimezone.AsiaTokyo]: "Asia/Tokyo",
    [SupportedTimezone.AsiaDubai]: "Asia/Dubai",
    [SupportedTimezone.AmericaNewYork]: "America/New_York",
    [SupportedTimezone.AmericaToronto]: "America/Toronto"
};

const resolveIanaTimezone = (timezone?: SupportedTimezone | string): string | undefined => {
    if (!timezone) {
        return undefined;
    }

    return supportedTimezoneToIanaMap[timezone as SupportedTimezone] ?? timezone;
};

export const formatDateTime = (isoString: string, timezone?: SupportedTimezone | string) => {
    const date = new Date(isoString);
    const ianaTimezone = resolveIanaTimezone(timezone);

    const formattedDate = new Intl.DateTimeFormat("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        timeZone: ianaTimezone
    }).format(date);

    const timeParts = new Intl.DateTimeFormat("en-GB", {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
        timeZone: ianaTimezone
    }).formatToParts(date);

    const hour = timeParts.find((part) => part.type === "hour")?.value ?? "00";
    const minute = timeParts.find((part) => part.type === "minute")?.value ?? "00";
    const dayPeriod = (timeParts.find((part) => part.type === "dayPeriod")?.value ?? "").toLowerCase();
    const formattedTime = dayPeriod ? `${hour}:${minute} ${dayPeriod}` : `${hour}:${minute}`;

    const formattedTimezone = new Intl.DateTimeFormat("en-GB", {
        timeZone: ianaTimezone,
        timeZoneName: "short"
    }).formatToParts(date).find((part) => part.type === "timeZoneName")?.value ?? "UTC";

    return {date: formattedDate, time: formattedTime, timezone: formattedTimezone};
}
